export const remediationRecords = [
  {
    id: "REM001",
    learnerId: "L002",
    simulationId: "PS001",
    triggerEvent: "Clicked Link",
    triggeredAt: "2023-10-15T09:24:00Z",
    riskScoreDelta: 15,
    assignedModuleId: "TM010",
    dueDate: "2023-10-18",
    completionDate: "2023-10-17",
    status: "Completed",
    notificationsSent: ["learner"],
    managerNotified: false,
    adminNotified: false,
    completionScore: 88,
    riskAdjusted: true,
    riskAdjustmentDelta: -8,
  },
  {
    id: "REM002",
    learnerId: "L004",
    simulationId: "PS001",
    triggerEvent: "Submitted Credentials",
    triggeredAt: "2023-10-15T10:05:00Z",
    riskScoreDelta: 25,
    assignedModuleId: "TM001",
    dueDate: "2023-10-16",
    completionDate: null,
    status: "Overdue",
    notificationsSent: ["learner", "manager", "admin"],
    managerNotified: true,
    adminNotified: true,
    completionScore: null,
    riskAdjusted: false,
    riskAdjustmentDelta: 0,
  },
  {
    id: "REM003",
    learnerId: "L008",
    simulationId: "PS001",
    triggerEvent: "Clicked Link",
    triggeredAt: "2023-10-15T11:42:00Z",
    riskScoreDelta: 15,
    assignedModuleId: "TM010",
    dueDate: "2023-10-18",
    completionDate: null,
    status: "In Progress",
    notificationsSent: ["learner"],
    managerNotified: false,
    adminNotified: false,
    completionScore: null,
    riskAdjusted: false,
    riskAdjustmentDelta: 0,
  },
  {
    id: "REM004",
    learnerId: "L002",
    simulationId: "PS003",
    triggerEvent: "Clicked Link",
    triggeredAt: "2023-11-20T14:10:00Z",
    riskScoreDelta: 15,
    assignedModuleId: "TM010",
    dueDate: "2023-11-23",
    completionDate: "2023-11-22",
    status: "Completed",
    notificationsSent: ["learner"],
    managerNotified: false,
    adminNotified: false,
    completionScore: 74,
    riskAdjusted: true,
    riskAdjustmentDelta: -5,
  },
  {
    id: "REM005",
    learnerId: "L004",
    simulationId: "PS003",
    triggerEvent: "Submitted Credentials",
    triggeredAt: "2023-11-20T14:33:00Z",
    riskScoreDelta: 25,
    assignedModuleId: "TM001",
    dueDate: "2023-11-21",
    completionDate: null,
    status: "Overdue",
    notificationsSent: ["learner", "manager", "admin"],
    managerNotified: true,
    adminNotified: true,
    completionScore: null,
    riskAdjusted: false,
    riskAdjustmentDelta: 0,
  },
];